import type { RiskAssetFiltersState } from "contexts/filters/risk-management-filters";

export const handleFilterCheckbox = (
  state: RiskAssetFiltersState,
  key: keyof RiskAssetFiltersState,
  value: string,
  checked: boolean | "indeterminate",
): RiskAssetFiltersState => {
  if (checked === "indeterminate") {
    return state;
  }

  const currentValues = new Set(state[key] as Array<string>);

  if (checked) {
    currentValues.add(value);
  } else {
    currentValues.delete(value);
  }

  return {
    ...state,
    [key]: Array.from(currentValues),
  };
};
